module.exports = __webpack_public_path__ + "static/img/webapps-01.062b4ed2.jpg";